import { render, staticRenderFns } from "./ListTipocontratoPage.vue?vue&type=template&id=1a9fb592&"
import script from "./ListTipocontratoPage.vue?vue&type=script&lang=js&"
export * from "./ListTipocontratoPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports